import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=233090f0&"
import script from "./IconButton.vue?vue&type=script&lang=ts&"
export * from "./IconButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports